import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "core/store";
import { InvitationReducerType } from "./reducer";

const invitationReducer = (state: RootState): InvitationReducerType =>
	state.invitation;

export const invitationShowHeaderSelector = createSelector(
	invitationReducer,
	(state) => state.showHeader
);

export const invitationActiveAccordionSelector = createSelector(
	invitationReducer,
	(state) => state.activeAccordion
);

export const invitationInvitationSelector = createSelector(
	invitationReducer,
	(state) => state.invitation
);
